import {
	subscriptionList,
	subscriptionShow,
} from '@/services/tv/subscriptions.service'

export default {
	namespaced: true,
	state: {
		// SERVICE SUBSCRIPTIONS
		subscriptionList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		subscription: {},

		// STATUS SERVICE SUBSCRIPTIONS
		subscriptionListStatus: 'pending',
	},
	getters: {
		// SERVICE SUBSCRIPTIONS
		getSubscriptionList(state) {
			return state.subscriptionList
		},
		getSubscription(state) {
			return state.subscription
		},

		// STATUS SERVICE SUBSCRIPTIONS
		getSubscriptionListStatus(state) {
			return state.subscriptionListStatus
		},
	},
	mutations: {
		// SERVICE SUBSCRIPTIONS
		SUBSCRIPTION_LIST(state, value) {
			state.subscriptionList = value
		},
		SET_SUBSCRIPTION(state, value) {
			state.subscription = value
		},

		// STATUS SERVICE SUBSCRIPTIONS
		SUBSCRIPTION_LIST_STATUS(state, value) {
			state.subscriptionListStatus = value
		},
	},
	actions: {
		// Service Subscriptions
		async fetchSubscriptionList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('SUBSCRIPTION_LIST_STATUS', 'pending')
			commit('SUBSCRIPTION_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await subscriptionList(params)
				commit('SUBSCRIPTION_LIST_STATUS', 'init')
				commit('SUBSCRIPTION_LIST', data)
				return data
			} catch (error) {
				commit('SUBSCRIPTION_LIST_STATUS', 'init')
				throw error
			}
		},
		async fetchSubscriptionByID({ commit }, params) {
			commit('SUBSCRIPTION_LIST_STATUS', 'pending')
			try {
				const { data } = await subscriptionShow(params)
				commit('SUBSCRIPTION_LIST_STATUS', 'init')
				commit('SET_SUBSCRIPTION', data.data)
				return data
			} catch (error) {
				commit('SUBSCRIPTION_LIST_STATUS', 'init')
				return error
			}
		},
	},
}
